import Select, { OptionType } from './Select';

export type { OptionType };

export default Select;
